module.exports = __webpack_public_path__ + "img/I2C_Fig05.f5341974.png";